import {
  Grid,
  FormControl,
  Typography,
  TextField,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  getData,
  storeData,
  checkEditPage,
  callChoice,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import { isEmpty } from "lodash";
import CustomList from "../../components/BoxRightContent/CustomList";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";

const header = {
  headers: {
    "Content-Type": "application/json",
  },
};
const Investinfoincome = (props) => {
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [isCheck, setIsCheck] = useState(false);
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  // Country
  const [country, setCountry] = useState({});
  const [textCountry, setTextCountry] = useState("");
  // Choices
  const [choice, setChoice] = useState([]);
  const [oldChoice, setOldChoice] = useState([]);
  const [textChoice, setTextChoice] = useState("");
  const [isTextChoice, setIsTextChoice] = useState(false);
  // Text Error
  const [countryError, setCountryError] = useState("");
  const [textCountryError, setTextCountryError] = useState("");
  const [textChoiceError, setTextChoiceError] = useState("");
  // Options data
  const [countries, setCountries] = useState([]);
  const [choices, setChoices] = useState([]);
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const f3 = getData("f3_source_income");
  const f3Purpose = getData("f3_purpose_invest");
  const f3Asset = getData("f3_asset");
  const f3Career = getData("f3_career");
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(f3Career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callGetCountry = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/source_income`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setCountries(data);
            if (!isEmpty(f3.f3_source)) {
              data.forEach((ele) => {
                if (ele.Mfnt_Id === parseInt(f3.f3_source)) {
                  setCountry(ele);
                }
              });
            } else {
              data.forEach((ele, i) => {
                if (i === 0) {
                  setCountry(ele);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetChoice = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/constant/source_income_choice`,
      )
        .then((res) => {
          setIsLoading(false);
          setChoices(res?.data?.Data);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const onInitData = async () => {
    let isHaveOld = false;
    if (!isEmpty(f3)) {
      let oldTxtCountry = "";
      if (!isEmpty(f3.f3_source_text)) {
        oldTxtCountry = f3.f3_source_text;
        isHaveOld = true;
        setTextCountry(oldTxtCountry);
      } else {
        oldTxtCountry = "";
        setTextCountry(oldTxtCountry);
      }

      let oldChoices = [];
      if (f3.f3_by_employee === 1) {
        oldChoices.push("Salary");
        isHaveOld = true;
      }
      if (f3.f3_by_heritage === 1) {
        oldChoices.push("Heritage");
        isHaveOld = true;
      }
      if (f3.f3_by_saving === 1) {
        oldChoices.push("Savings");
        isHaveOld = true;
      }
      if (f3.f3_by_invest === 1) {
        oldChoices.push("Investment");
        isHaveOld = true;
      }
      if (f3.f3_by_retired === 1) {
        oldChoices.push("Retire");
        isHaveOld = true;
      }
      if (f3.f3_by_private_business === 1) {
        oldChoices.push("Business");
        isHaveOld = true;
      }
      if (f3.f3_by_other === "1") {
        oldChoices.push("Other (please specify)");
        isHaveOld = true;
      }
      setChoice(oldChoices);
      setOldChoice(oldChoices);

      let oldTxtChoice = "";
      if (!isEmpty(f3.f3_by_other_text)) {
        oldTxtChoice = f3.f3_by_other_text;
        isHaveOld = true;
        setTextChoice(oldTxtChoice);
      } else {
        oldTxtChoice = "";
        setTextChoice(oldTxtChoice);
      }

      if (isHaveOld) {
        setIsCheck(true);
      }
    }
  };
  const handleChangeCountry = (e, value) => {
    setTextCountry("");
    setTextCountryError("");
    setCountryError("");
    if (!isEmpty(value)) {
      setCountry(value);
    }
  };
  const handleChangeText = (e) => {
    setTextCountryError("");
    if (!isEmpty(e)) {
      setTextCountry(e.target.value);
    } else {
      setTextCountry("");
    }
  };
  const handleChangeChoice = (name, id, check) => {
    setOldChoice("");
    const data = [...choice];
    if (name.includes("Other")) {
      setTextChoice("");
      setTextChoiceError("");
    }
    if (check) {
      data.push(name);
      setChoice(data);
      if (name.includes("Other")) {
        setIsTextChoice(true);
      }
      setIsCheck(true);
    } else {
      if (name.includes("Other")) {
        setIsTextChoice(false);
      }
      const newData = data.filter(function (item) {
        return item !== name;
      });
      !isEmpty(newData) ? setChoice(newData) : setChoice([]);
      if (choice.length === 1) {
        setIsCheck(false);
      }
    }
  };
  const handleChangeTextChoice = (e) => {
    setIsTextChoice(true);
    setTextCountryError("");
    if (!isEmpty(e)) {
      setTextChoice(e.target.value);
    } else {
      setTextChoice("");
    }
  };
  const setTextSummary = async (data) => {
    let text = {
      source: country.Other !== 1 ? country.Mfnt_NameTh : data.f3_source_text,
    };
    choices.forEach((ele) => {
      if (data.f3_by_employee === 1 && ele.Mfnc_NameTh.includes("เงินเดือน")) {
        text.employee = ele.Mfnc_NameTh;
      }
      if (data.f3_by_heritage === 1 && ele.Mfnc_NameTh.includes("มรดก")) {
        text.heritage = ele.Mfnc_NameTh;
      }
      if (data.f3_by_saving === 1 && ele.Mfnc_NameTh.includes("เงินออม")) {
        text.saving = ele.Mfnc_NameTh;
      }
      if (data.f3_by_invest === 1 && ele.Mfnc_NameTh.includes("การลงทุน")) {
        text.invest = ele.Mfnc_NameTh;
      }
      if (data.f3_by_retired === 1 && ele.Mfnc_NameTh.includes("เงินเกษียณ")) {
        text.retired = ele.Mfnc_NameTh;
      }
      if (
        data.f3_by_private_business === 1 &&
        ele.Mfnc_NameTh.includes("ประกอบธุรกิจ")
      ) {
        text.business = ele.Mfnc_NameTh;
      }
      if (data.f3_by_other === "1") {
        text.other = data.f3_by_other_text;
      }
    });

    storeData("text_invest_income", text);
    storeData("f3_source_income", data);
    if (editUrl) {
      let preData = {
        head_token,
        f3_source: data.f3_source,
        f3_source_text: data.f3_source_text,
        f3_by_employee: data.f3_by_employee,
        f3_by_heritage: data.f3_by_heritage,
        f3_by_saving: data.f3_by_saving,
        f3_by_invest: data.f3_by_invest,
        f3_by_retired: data.f3_by_retired,
        f3_by_private_business: data.f3_by_private_business,
        f3_by_other: data.f3_by_other,
        f3_by_other_text: data.f3_by_other_text,

        f3_invest: f3Purpose.f3_invest,
        purpose_json: f3Purpose.purpose_json,

        f3_valuable: f3Asset.f3_valuable,
        f3_outcome: f3Asset.f3_outcome,

        f3_career: f3Career.f3_career,
        f3_career_text: f3Career.f3_career_text,
        f3_business: !isEmpty(f3Career.f3_business) ? f3Career.f3_business : "",
        f3_business_text: f3Career.f3_business_text,
        f3_income: f3Career.f3_income,
        f3_position: f3Career.f3_position,
        f3_officename: f3Career.f3_officename,
        f3_own: "1",
      };
      postData(preData);
    } else {
      props.history.push("/invest_info_purpose");
    }
  };
  const postData = async (data) => {
    setIsLoading(true);
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}/form/career_and_financial/manp`,
        data,
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            storeData("editPage", "invest_income");
            props.history.push("/summary");
          }
        })
        .catch((e) => {
          setModalErrorDes(e);
          setIsModalError(true);
          setIsLoading(false);
        });
    } catch (error) {
      setModalErrorDes(error);
      setIsModalError(true);
      setIsLoading(false);
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();
    let valid = validate();
    if (await valid) {
      let prepareData = {
        f3_source: country.Mfnt_Id.toString(),
        f3_source_text: !isEmpty(textCountry) ? textCountry : "",
        f3_by_employee: 0,
        f3_by_heritage: 0,
        f3_by_saving: 0,
        f3_by_invest: 0,
        f3_by_retired: 0,
        f3_by_private_business: 0,
        f3_by_other: "0",
        f3_by_other_text: !isEmpty(textChoice) ? textChoice : "",
      };
      if (!isEmpty(choice)) {
        choice.forEach((ele) => {
          if (ele.includes("Salary")) {
            prepareData.f3_by_employee = 1;
          } else if (ele.includes("Heritage")) {
            prepareData.f3_by_heritage = 1;
          } else if (ele.includes("Savings")) {
            prepareData.f3_by_saving = 1;
          } else if (ele.includes("Investment")) {
            prepareData.f3_by_invest = 1;
          } else if (ele.includes("Retire")) {
            prepareData.f3_by_retired = 1;
          } else if (ele.includes("Business")) {
            prepareData.f3_by_private_business = 1;
          } else if (ele.includes("Other")) {
            prepareData.f3_by_other = "1";
          }
        });
      }
      await setTextSummary(prepareData);
    }
  };
  const validate = async () => {
    let valid = true;
    if (isEmpty(country)) {
      valid = false;
      setCountryError("กรุณาระบุประเทศ");
    }
    if (country.Mfnt_Id === 2 && isEmpty(textCountry)) {
      valid = false;
      setTextCountryError("กรุณาระบุประเทศ");
    }
    if (!isEmpty(choice)) {
      choice.forEach((ele) => {
        if (ele.includes("Other") && isEmpty(textChoice)) {
          valid = false;
          setTextChoiceError("กรุณาระบุแหล่งที่มาของรายได้อื่น ๆ");
        }
      });
    }
    return valid;
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
        callGetCountry();
        callGetChoice();
        onInitData();
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.sourceIncome?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? props.history.push("/familystatuschild") : ""
            }
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btnPrimary={"ตกลง"}
          ></DialogError>
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.sourceIncome}
                        clickBack={(e) =>
                          props.history.push("/familystatuschild")
                        }
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.sourceIncome?.title}
                          />
                          <PanelScrollBar
                            size="full"
                            content={
                              <>
                                <Grid>
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20">
                                      {
                                        translations?.[lang]?.sourceIncome
                                          ?.sub_title_1
                                      }
                                    </Typography>
                                  </Grid>
                                  <Grid className="input-form">
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <Autocomplete
                                        options={countries}
                                        value={country}
                                        getOptionLabel={(option) =>
                                          option.Mfnt_NameTh
                                            ? option.Mfnt_NameTh
                                            : ""
                                        }
                                        onChange={(e, value) =>
                                          handleChangeCountry(e, value)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputProps={{
                                              ...params.InputProps,
                                              // readOnly: true,
                                            }}
                                            variant="standard"
                                            placeholder="กรุณาเลือก"
                                          />
                                        )}
                                      />
                                      <FormHelperText className="text-error">
                                        {countryError}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                  {country.Mfnt_Id === 2 ? (
                                    <Grid className="input-form">
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        error
                                      >
                                        <TextField
                                          fullWidth
                                          variant="standard"
                                          value={textCountry}
                                          placeholder="ประเทศอื่นๆ (โปรดระบุ)"
                                          onChange={handleChangeText}
                                        />
                                        <FormHelperText className="text-error">
                                          {textCountryError}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    <Grid></Grid>
                                  )}
                                </Grid>
                                <Grid className="choices-box">
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20 ">
                                      {
                                        translations?.[lang]?.sourceIncome
                                          ?.sub_title_2
                                      }
                                    </Typography>
                                  </Grid>
                                  <CustomList
                                    page="income"
                                    lang={lang}
                                    data={choices}
                                    value={oldChoice}
                                    onChange={handleChangeChoice}
                                  />
                                  {isTextChoice || !isEmpty(textChoice) ? (
                                    <Grid className="input-form">
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        error
                                      >
                                        <TextField
                                          fullWidth
                                          variant="standard"
                                          value={textChoice}
                                          placeholder="กรุณาระบุแหล่งที่มาของรายได้อื่น ๆ"
                                          onChange={handleChangeTextChoice}
                                        />
                                        <FormHelperText className="text-error">
                                          {textChoiceError}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    <Grid></Grid>
                                  )}
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.sourceIncome?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(Investinfoincome);
